import { Profile } from './containers';

/**
 * ProfilePage 컴포넌트
 */
export default Profile; 